import moment from 'moment';

Vue.directive('click-outside', {
    bind: function (el, binding, vnode) {
      el.clickOutsideEvent = function (event) {
        // here I check that click was outside the el and his childrens
        if (!(el == event.target || el.contains(event.target))) {
          // and if it did, call method provided in attribute value
          vnode.context[binding.expression](event);
        }
      };
      document.body.addEventListener('click', el.clickOutsideEvent)
    },
    unbind: function (el) {
      document.body.removeEventListener('click', el.clickOutsideEvent)
    },
});

if($('#notifications-component').length){
    var app = new Vue({
        el: '#notifications-component',
        data: {
            unread: false,
            open: false,
            notifications: [],
            offset: 0,
            limit: 10,
            loadedAll: false,
            api_url: api_url
        },
        methods: {
            get: function() {
                axios.get(this.api_url + '/api/v1/notifications?limit='+this.limit+'&offset='+this.offset, {
                    'headers': {
                        'Accept': 'application/json'
                    }        
                }).then(response => {
                    let notifications = response.data.data;

                    if(notifications.length < 10){
                        this.loadedAll = true;
                    }

                    if(this.notifications.length && notifications){
                        notifications.forEach((notification)=>{
                            this.notifications.push(notification);
                        })
                    }else{
                        this.notifications = notifications;
                    }

                    this.offset = this.offset + this.limit;
                }).catch(error => {
                    console.log(error)
                    this.errored = true
                })
            },
            getUnread() {
                axios.get(this.api_url + '/api/v1/get-unread-notifications-count?limit=' + this.limit + '&offset=' + this.offset, {
                    'headers': {
                        'Accept': 'application/json'
                    }
                }).then(response => {
                    if (response.data === 1) {
                        this.unread = true;
                    }
                }).catch(error => {
                    console.log(error)
                })
            },
            getNotifications() {
                if (this.notifications.length === 0) {
                    this.get()
                }
            },
            markAllAsRead: function() {
                axios.put('/notifications/read-all')
                .then((response) =>  {
                    let notifications = this.notifications.map((notification)=>{
                        notification.read_at = {date: Date.now()}
                        return notification;
                    })
                    this.notifications = notifications;
                    this.unread = false;
                })
                .catch(function (error) {
                    console.log(error)
                })
            },
            markAsRead: function(clickedNotification) {
                return axios.put('/notifications/read/'+clickedNotification.id)
                .then((response) =>  {
                    this.unread = false
                    this.notifications.map((notification)=>{
                        if(notification.id == clickedNotification.id){
                            notification.read_at = {date: Date.now()}
                        }
                        if(!notification.read_at){
                            this.unread = true
                        }
                    })
                    if(clickedNotification.data.subject.path){
                        window.location.href = clickedNotification.data.subject.path;
                    }else{
                        window.location.href = clickedNotification.data.subject.link;
                    }
                })
                .catch(function (error) {
                    console.log(error)
                })
            },
            toggleDropdown: function(){
                this.open = !this.open;
            },
            hide: function(){
                this.open = false;
            },
            getTime: function(date){
                var dateFormat = 'LLL';
                var testDateUtc = moment.utc(date);
                var localDate = testDateUtc.local();
                return localDate.format(dateFormat);
            }
        },
        mounted () {
            this.getUnread();
        },
    });
}